import React from 'react'
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import { MARKDOWN } from '../../constants/contentTypes';


const MarkdownRenderer =  (props) => {
    let escapeHtml = (props.ContentType === MARKDOWN)

    if(props.text.length <= 1){
        console.warn("you probably dont mean to render at least 1-2 characters in markdown")
    }
   return(
        <div className="bcs-markdown" style={props.inline ? {display: 'inline-block'} : null}>
            <ReactMarkdown source={props.text} escapeHtml={escapeHtml}/>
        </div>
   )
}

MarkdownRenderer.propTypes = {
    text: PropTypes.string.isRequired
}

MarkdownRenderer.defaultProps = {
    text: ''
}

export default MarkdownRenderer



// WEBPACK FOOTER //
// ./src/components/MarkdownRenderer/index.js